import React, { Component, memo } from 'react'
import $, { post } from 'jquery';
import axios from "axios";
import Header from '../../Header';
import BypassHeader from '../../BypassHeader';
import LeftPanelUnauth from "../../commons/LeftPanelUnauth";
import LeftPanel from '../../LeftPanel';
import ExploreTopBar from '../ExploreTopBar';
import "../main-explore.min.css";
import { isMobileDevice } from "../../commons/CommonFunctions";
import { authService } from "../../auth";

import HashTagsTopSection from './HashTagsTopSection';
import HashTagsRecentActivity from './HashTagsRecentActivity';
import HashTagsTopContributors from './HashTagsTopContributors';
import HashTagsBlogs from './HashTagsBlogs';
import HashTagsPhotos from './HashTagsPhotos';
import HashTagsVideos from './HashTagsVideos';
import HashTagsProjects from './HashTagsProjects';
import HashTagsForums from './HashTagsForum';
import HashTagsPolls from './HashTagsPoll';
import HashTagsOthers from './HashTagsOthers';
import Loader from "react-loader-spinner";
import NotFound from "../../404";
import HashTagsStudios from './HashTagsStudios';
import HashTagsDocuments from './HashTagsDocuments';
import Breadcumbs from '../../Breadcumbs';

if (isMobileDevice()) {
    import('../../commons/styles/responsive-useragent.css').then(() => {
        console.log("Imported mobile css");
    });
}

export class HashTagsMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            loginSuccess: authService.isAuthenticated(),
            tagName: this.props.match.params.slug && this.props.match.params.slug.toLowerCase() ,
            page: 0,
            size: 4,
            tagTopcontributors: [],
            blogList: [],
            photosList: [],
            videoesList: [],
            othersList: [],
            projectList: [],
            forumList: [],
            pollList: [],
            topContributorsList: [],
            relatedTagsList: [],
            recentActivityList: [],
            studioList: [],
            documentList : [],
            responseMessage: '', 
            pageNotExist: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match?.params?.slug && (nextProps.match.params.slug !== this.props.match.params.slug)) {
            $('.topsearch').removeClass('active');
            document.body.classList.remove('searchDropActive');
            $(".search_block_top1").removeClass("active-search");
            $("#header").removeClass("searchact");
            this.setState({
                tagName: nextProps.match.params.slug.toLowerCase()
            }, () => {
                this.getHashtagsDetails();
            })
        }
    }

    componentDidMount() {
        this.getHashtagsDetails();
    }

    getHashtagsDetails = () => {
        let postData= {
            hashtag: this.state.tagName
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/recommend/statushashtag/`,
            headers: { 'Content-Type': 'application/json' },
            data: postData,
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.status === 200) {
                if (this.state.loginSuccess) {
                    this.getRecentActivity();
                    this.getProjectDetails();
                } 
                this.getBlogDetails();
                this.getPhotoDetails();
                this.getStudioDetails();
                this.getVideoDetails();
                this.getDocumentsDetails();
                this.getOtherDetails();
                this.getForumDetails();
                this.getPollDetails();
                this.getTopContributorsDetails(0, 5);
                this.getRelatedTagsDetails(0, 11);
            }
            if (response && response.data && response.data.status === 410) {
                this.setState({
                    'pageNotExist': true
                })
            }
        }).catch((err) => {
            console.log(err);
            this.setState({
                'pageNotExist': err.response && err.response.status === 410 ? true : false
            })
        });
    }

    signUpRequired = () => {
        this.setState({ 'signUpRequired': true })
        window.$('#signupModal').modal('show');
    }

    getRecentActivity = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/tags/tagrecentactivity/?userId=' + this.state.userData.userId + "&hashTag=" + this.state.tagName + "&page=" + this.state.page + "&size=10",
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'recentActivityList': response.data.body.content,
                })
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getBlogDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        let url = `${process.env.REACT_APP_userServiceURL}/unauth/getNewsFeed/hashTag/viewAll/?hashTag=${this.state.tagName}&category=POST&newsFeedType=ARTICLE&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        if(this.state.loginSuccess) {
            url = `${process.env.REACT_APP_userServiceURL}/tags/getNewsFeed/hashTag/viewAll/?otherUserId=${this.state.userData.userId}&hashTag=${this.state.tagName}&category=POST&newsFeedType=ARTICLE&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        }
        axios({
            method: 'get',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'blogList': response.data.body.content,
                })
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response.data.message
            })
        });
    }

    getVideoDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        let url = `${process.env.REACT_APP_userServiceURL}/unauth/getNewsFeed/hashTag/viewAll/?hashTag=${this.state.tagName}&category=POST&newsFeedType=VIDEO&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        if(this.state.loginSuccess) {
            url = `${process.env.REACT_APP_userServiceURL}/tags/getNewsFeed/hashTag/viewAll/?otherUserId=${this.state.userData.userId}&hashTag=${this.state.tagName}&category=POST&newsFeedType=VIDEO&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        }
        axios({
            method: 'get',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'videoesList': response.data.body.content,
                })
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response.data.message
            })
        });
    }

    getPhotoDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        let url = `${process.env.REACT_APP_userServiceURL}/unauth/getNewsFeed/hashTag/viewAll/?hashTag=${this.state.tagName}&category=POST&newsFeedType=IMAGE&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        if(this.state.loginSuccess) {
            url = `${process.env.REACT_APP_userServiceURL}/tags/getNewsFeed/hashTag/viewAll/?otherUserId=${this.state.userData.userId}&hashTag=${this.state.tagName}&category=POST&newsFeedType=IMAGE&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        }
        axios({
            method: 'get',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'photosList': response.data.body.content,
                })
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response.data.message  
            })
        });
    }

    getStudioDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        axios({
            method: 'get',
            url: `${process.env.REACT_APP_userServiceURL}/tags/studio/list?${this.state.loginSuccess ? `otherUserId=${this.state.userData.userId}` : ""}&hashTag=${this.state.tagName}&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'studioList': response.data.body?.content,
                }) 
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response?.data?.message  
            })
        });
    }

    getOtherDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        let url = `${process.env.REACT_APP_userServiceURL}/unauth/getNewsFeed/hashTag/viewAll/?hashTag=${this.state.tagName}&category=POST&newsFeedType=FEED&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        if(this.state.loginSuccess) {
            url = `${process.env.REACT_APP_userServiceURL}/tags/getNewsFeed/hashTag/viewAll/?otherUserId=${this.state.userData.userId}&hashTag=${this.state.tagName}&category=POST&newsFeedType=FEED&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        }
        axios({
            method: 'get',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'othersList': response.data.body.content,
                })
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response.data.message
            })
        });
    }

    getProjectDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/tags/getTagNewsFeed/project/?userId=' + this.state.userData.userId + "&hashTag=" + this.state.tagName + "&category=PROJECTS" + "&page=" + this.state.page + "&size=" + this.state.size,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'projectList': response.data.body.content
                })
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response.data.message  
            })
        });
    }

    getForumDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        let url = `${process.env.REACT_APP_userServiceURL}/unauth/getNewsFeed/hashTag/?hashTag=${this.state.tagName}&category=FORUM&page=${this.state.page}&size=5`;
        if(this.state.loginSuccess) {
            url = `${process.env.REACT_APP_userServiceURL}/tags/getNewsFeed/hashTag/?userId=${this.state.userData.userId}&hashTag=${this.state.tagName}&category=FORUM&page=${this.state.page}&size=5`;
        }
        axios({
            method: 'get',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'forumList': response.data.body.content
                })
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response.data.message
            })
        });
    }

    getPollDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        let url = `${process.env.REACT_APP_userServiceURL}/unauth/getNewsFeed/hashTag/?hashTag=${this.state.tagName}&category=POLL&page=${this.state.page}&size=5`;
        if(this.state.loginSuccess) {
            url = `${process.env.REACT_APP_userServiceURL}/tags/getNewsFeed/hashTag/?userId=${this.state.userData.userId}&hashTag=${this.state.tagName}&category=POLL&page=${this.state.page}&size=5`;
        }
        axios({
            method: 'get',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'pollList': response.data.body.content
                })
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response.data.message
            })
        });
    }

    getTopContributorsDetails = (page, size) => {
        let url = `${process.env.REACT_APP_userServiceURL}/unauth/topcontributorhashtag/?hashTag=${this.state.tagName}&page=${page}&size=${size}`;
        if(this.state.loginSuccess) {
            url = `${process.env.REACT_APP_userServiceURL}/tags/topcontributorhashtag/?userId=${this.state.userData.userId}&loginUserId=${this.state.userData.userId}&hashTag=${this.state.tagName}&category=POLL&page=${page}&size=${size}`;
        }
        axios({
            method: 'get',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'topContributorsList': response.data.body.content
                })
            }
        }).catch((err) => {
            console.log(err);
            this.setState({
                
            })
        });
    }

    getRelatedTagsDetails = (page, size) => {
        let url = `${process.env.REACT_APP_userServiceURL}/unauth/relatedhashtags/?hashTag=${this.state.tagName}&page=${page}&size=${size}`;
        if(this.state.loginSuccess) {
            url = `${process.env.REACT_APP_userServiceURL}/tags/relatedhashtags/?userId=${this.state.userData.userId}&hashTag=${this.state.tagName}&page=${page}&size=${size}`;
        }
        axios({
            method: 'get',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body) {
                this.setState({
                    'relatedTagsList': response.data.body
                })
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getUnAuthProjectDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/unauth/tags/getTagNewsFeed/project/?hashTag=' + this.state.tagName + "&category=PROJECTS" + "&page=" + this.state.page + "&size=" + this.state.size,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'projectList': response.data.body.content
                })
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response.data.message
            })
        });
    }


    getDocumentsDetails = () => {
        this.setState({
            'responseMessage': ""
        })
        let url = `${process.env.REACT_APP_userServiceURL}/unauth/getNewsFeed/hashTag/viewAll/?hashTag=${this.state.tagName}&category=POST&newsFeedType=DOCUMENT&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        if(this.state.loginSuccess) {
            url = `${process.env.REACT_APP_userServiceURL}/tags/getNewsFeed/hashTag/viewAll/?otherUserId=${this.state.userData.userId}&hashTag=${this.state.tagName}&category=POST&newsFeedType=DOCUMENT&page=${this.state.page}&size=${this.state.size}&auth=${this.state.loginSuccess}`;
        }
        axios({
            method: 'get',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!' && response.data.body?.content) {
                this.setState({
                    'documentList': response.data.body,
                })
            }
            this.setState({
                'responseMessage': response.data.message
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                'responseMessage': err.response.data.message,
            })
        });
    }


    render() {
        const { tagName, pageNotExist } = this.state   
        return (
            <div className={!this.state.loginSuccess ? "wrapper projectpage explorepage nologinpage"
                : "wrapper projectpage explorepage"}>

                {this.state.loginSuccess ? <Header /> : <BypassHeader />}

                <main className="dgcontainer hm3col">
                    <div className="container">
                        {pageNotExist ? 
                            <NotFound /> : 

                            <div className="row">

                                {this.state.loginSuccess ? <LeftPanel /> : <LeftPanelUnauth signUpRequired={this.signUpRequired} />}

                                <div className="col-md-9">
                                    <div className="projectinn explore trending hashtag exploreExtra">
                                        {this.props.match.params.slug && <Breadcumbs crumbs={[{ "name": `Explore`, "path": `/explore-daily-edition` }, { "name": `Hashtag`, "path": `/explore-hashtag` }, { "name": `${this.props.match.params.slug}`, "path": null } ]} />}
                                        <ExploreTopBar tagName={"Hashtags"} />

                                        <HashTagsTopSection isDisplay={false} tagName={this.props.match.params.slug} blogListData={this.state.blogList} imageListData={this.state.photosList} videoListData={this.state.videoesList} projectListData={this.state.projectList} studioListData={this.state.studioList} forumListData={this.state.forumList} pollListData={this.state.pollList} documentsListData={this.state.documentList?.content} othersListData={this.state.othersList} relatedTagsListData={this.state.relatedTagsList} hashTagType="global" />

                                        {this.state.topContributorsList && this.state.topContributorsList.length > 0 &&
                                            <HashTagsTopContributors tagName={tagName} topContributorsListData={this.state.topContributorsList} hashTagType="global" />
                                        }

                                        {this.state.recentActivityList && this.state.recentActivityList.length > 0 &&
                                            <HashTagsRecentActivity tagName={tagName} recentActivityListData={this.state.recentActivityList} hashTagType="global" />
                                        }

                                        {this.state.photosList && this.state.photosList.length > 0 &&
                                            <HashTagsPhotos tagName={tagName} imageListData={this.state.photosList} hashTagType="global" />
                                        }

                                        {this.state.videoesList && this.state.videoesList.length > 0 &&
                                            <HashTagsVideos tagName={tagName} videoListData={this.state.videoesList} hashTagType="global" />
                                        }

                                        {this.state.blogList && this.state.blogList.length > 0 &&
                                            <HashTagsBlogs tagName={tagName} blogListData={this.state.blogList} hashTagType="global" />
                                        }

                                        {this.state.documentList && this.state.documentList?.content?.length > 0 &&
                                            <HashTagsDocuments tagName={tagName} documentsListData={this.state.documentList} hashTagType="global" />
                                        }

                                        {this.state.projectList && this.state.projectList.length > 0 &&
                                            <HashTagsProjects tagName={tagName} projectListData={this.state.projectList} hashTagType="global" />
                                        }

                                        {this.state.studioList?.length > 0 &&
                                            <HashTagsStudios tagName={tagName} studioListData={this.state.studioList} hashTagType="global" />
                                        }

                                        {this.state.forumList && this.state.forumList.length > 0 &&
                                            <HashTagsForums tagName={tagName} forumListData={this.state.forumList} hashTagType="global" />
                                        }

                                        {this.state.pollList && this.state.pollList.length > 0 &&
                                            <HashTagsPolls tagName={tagName} pollListData={this.state.pollList} hashTagType="global" />
                                        }

                                        {this.state.othersList && this.state.othersList.length > 0 &&
                                            <HashTagsOthers tagName={tagName} othersListData={this.state.othersList} hashTagType="global" />
                                        }

                                        {this.state.responseMessage !== 'Success!' && (this.state.topContributorsList && this.state.topContributorsList.length == 0) && (this.state.blogList && this.state.blogList.length == 0) && 
                                        (this.state.photosList && this.state.photosList.length == 0) && (this.state.videoesList && this.state.videoesList.length == 0) && (this.state.forumList && this.state.forumList.length == 0) && 
                                        (this.state.pollList && this.state.pollList.length == 0) && (this.state.othersList && this.state.othersList.length == 0) && (this.state.studioList && this.state.studioList.length === 0) && (this.state.projectList && this.state.projectList.length == 0) && <div style={{
                                            width: '100%', height: '100%', position: 'fixed', top: 0, left: 0,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                                        }}>
                                            <Loader
                                                type="Grid"
                                                color="#dcde63"
                                                height={60}
                                                width={60}
                                                timeout={3000}
                                            />
                                        </div>}
                                        {this.state.responseMessage === 'Success!' && (this.state.topContributorsList && this.state.topContributorsList.length == 0) && /* (this.state.recentActivityList && this.state.recentActivityList.length == 0) && */ (this.state.blogList && this.state.blogList.length == 0) && 
                                        (this.state.photosList && this.state.photosList.length == 0) && (this.state.videoesList && this.state.videoesList.length == 0) && (this.state.forumList && this.state.forumList.length == 0) && 
                                        (this.state.pollList && this.state.pollList.length == 0) && (this.state.othersList && this.state.othersList.length == 0) && (this.state.studioList && this.state.studioList.length === 0) && (this.state.projectList && this.state.projectList.length == 0) && (this.state.documentList && this.state.documentList?.content?.length === 0) && <div className="zdata zfeed">
                                            <div className="imgbox">
                                                <img src="https://cdn.dscovr.com/images/zeroNodateNew1.webp"
                                                    onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/zeroNodateNew1.png"}}
                                                    width={520}
                                                    alt=""/>
                                            </div>
                                            <div className="desc">
                                                <p>No data available</p>
                                            </div>
                                        </div>}

                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                </main>

            </div>
        )
    }
}

export default memo(HashTagsMain)
